import type { Location } from '@remix-run/react';

import { COMMUNITY_ROUTES, isContentPageRoute } from '~/constants/community';

import { parseProfileTab } from '../members/$id/_utils/tabs';

// Scroll memory key for community routes inside the layout's <main>.
// - Feed routes (global + per-space): keyed by pathname only.
// - Member profile: keyed by pathname + active tab so each tab keeps its own
//   scroll position (tabs are query-driven, same pathname).
// - Content page: keyed by pathname only, so its tag filter (?tags=) keeps the
//   scroll position. Its resource pages stay null.
// - All other routes (post detail, notifications, messages, etc.): null,
//   meaning scroll resets to 0 on navigation as before.
export const buildScrollMemoryKey = (location: Location): string | null => {
  const { pathname, search } = location;

  if (pathname === COMMUNITY_ROUTES.root || pathname.startsWith(`${COMMUNITY_ROUTES.root}/channels/`)) {
    return `community-feed-scroll:${pathname}`;
  }

  if (pathname.startsWith(`${COMMUNITY_ROUTES.root}/members/`)) {
    const tab = parseProfileTab(new URLSearchParams(search).get('tab'));
    return `community-profile-scroll:${pathname}:${tab}`;
  }

  if (isContentPageRoute(pathname)) {
    return `community-content-page-scroll:${pathname}`;
  }

  return null;
};
